import { Component, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent {
  @ViewChild('Scroll') scrollElement!: ElementRef;
  @Output() emitterOpenTerms = new EventEmitter<boolean>();
  @Output() emitterAccess = new EventEmitter<boolean>();
  @Output() termsAccepted = new EventEmitter<boolean>();

  canCheck: boolean = false;
  isChecked: boolean = false;
  activeTab: string = 'italiano';
  userCanAccess: boolean = false;

  constructor (private authService: AuthService) { }

  onScroll (event: any): void {
    const element = event.target;

    if (element.offsetHeight + element.scrollTop >= element.scrollHeight - 1) {
      this.canCheck = true;
    }
  }

  changeTab (tab: string): void {
    this.activeTab = tab;
    this.resetCheckState();
    //scroll reset
    if (this.scrollElement) {
      this.scrollElement.nativeElement.scrollTop = 0;
    }
  }

  resetCheckState (): void {
    this.canCheck = false;
    this.isChecked = false;
  }

  continueAndCloseTerms () {
    this.emitterOpenTerms.emit(false);
  }

  readyForAccess () {
    this.emitterAccess.emit(true);
  }

  // Emissione del token dopo l'accettazione dei termini
  acceptTerms () {
    const currentUser = sessionStorage.getItem('username') || '';
    this.authService.updateTermsAccepted(currentUser, true).subscribe({
      next: () => {
        this.termsAccepted.emit(true);
        this.emitterOpenTerms.emit(false);

        /*const token = sessionStorage.getItem('token') || '';
        if (token !== '') {
          this.token.emit(token); // get token and emit
        }
        if (this.waitingForTermsAcceptance) {
          this.waitingForTermsAcceptance = false;
          this.showForcePwdChange.emit(true);
        }*/
      },
      error (err) {
        console.error('Error:', err);
      },
    });


  }
}